import { Chip } from "@mui/material";

const StatusLayout = ({ status }) => {
  status = status?.toLowerCase();
  return (
    <Chip
      sx={{
        minWidth: "120px",
        textAlign: "center",

        backgroundColor:
          status === "completed" ||
          status === "active" ||
          status === "done" ||
          status === "paid" ||
          status === "approved" ||
          status === "available"
            ? "green"
            : status === "missing-info" ||
              status === "canceled" ||
              status === "overdue" ||
              status === "deleted" ||
              status === "quit" ||
              status === "denied" ||
              status === "departed"
            ? "#8B0000"
            : status === "not yet started" ||
              status === "pending" ||
              status === "in preparation" ||
              status === "scheduled" ||
              status === "pending-review" ||
              status === "under-review" ||
              status === "in progress" ||
              status === "in-progress" ||
              status === "not-paid" ||
              status === "pending-payment" ||
              status === "pending request"
            ? "#FFA400"
            : status === "first-approval"
            ? "#52b69a"
            : status === "to-do" || status === "open"
            ? "#3895D3"
            : status === "incoming" ||
              status === "in review" ||
              status === "upcoming"
            ? "#05c4e6"
            : status === "on-leave" || status === "on leave"
            ? "#FFA400"
            : status === "to-verify" || status === "submitted"
            ? "#FFC107"
            : status === "extended"
            ? "#f76c17"
            : status === "booked"
            ? "#FF5733"
            : status === "maintenance"
            ? "#444441"
            : status === "second-approval"
            ? "#008080"
            : "",

        color:
          status === "completed" ||
          status === "active" ||
          status === "paid" ||
          status === "first-approval" ||
          status === "available" ||
          status === "approved"
            ? "white"
            : status === "canceled" ||
              status === "overdue" ||
              status === "deleted" ||
              status === "quit" ||
              status === "denied" ||
              status === "departed" ||
              status === "booked"
            ? "white"
            : status === "not yet started" ||
              status === "in progress" ||
              status === "in-progress" ||
              status === "maintenance" ||
              status === "pending" ||
              status === "pending request"
            ? "white"
            : status === "to-do"
            ? "white"
            : status === "on-leave"
            ? "white"
            : status === "second-approval"
            ? "white" // White text for second approval
            : "",
      }}
      label={status}
    />
  );
};

export default StatusLayout;
